import { useState, useEffect } from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import app, { auth } from "./firebase"

const db = getFirestore(app);

function TabEditor() {
  const [tabText, setTabText] = useState("");
  const [previewFontSize, setPreviewFontSize] = useState(16);
  const [isTuningModalOpen, setIsTuningModalOpen] = useState(false);
  const [isChordModalOpen, setIsChordModalOpen] = useState(false);
  const [tuning, setTuning] = useState(["e", "B", "G", "D", "A", "E"]);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [tabTitle, setTabTitle] = useState("")
  const [tabArtist, setTabArtist] = useState("")
  const [tabDescription, setTabDescription] = useState("")

  const uploadTab = async () => {
    try {
      if (tabTitle === "" || tabArtist === "" || tabText === "") {
        throw new Error("Tab Information Incomplete")
      }
      await addDoc(collection(db, "tabs"), {
        artist: tabArtist,
        title: tabTitle,
        description: tabDescription,
        content: tabText ,
        username: auth.currentUser.email,
        likes: []
      })
    } catch (e) {
      console.error("Uploading error: ", e)
      alert(e);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      user ? setIsSignedIn(true) : setIsSignedIn(false);
    });
    
    return unsubscribe;
  }, []);

  const handleClear = () => setTabText("");

  const saveTab = () => {
    localStorage.setItem("savedTab", tabText);
    alert("Tab saved!");
  };

  const loadTab = () => {
    const savedTab = localStorage.getItem("savedTab");
    if (savedTab) {
      setTabText(savedTab);
      alert("Tab loaded!");
    } else {
      alert("No saved tab found.");
    }
  };

  const insertTemplate = () => {
    const template = tuning
      .map((string) => `${string}|--------------------|--------------------|--------------------|--------------------|`)
      .join("\n");
    setTabText((prevTab) => prevTab + "\n" + template + "\n");
  };

  const downloadTab = () => {
    const blob = new Blob([tabText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "guitar_tab.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  const increaseFontSize = () => setPreviewFontSize((prevSize) => prevSize + 2);
  const decreaseFontSize = () =>
    setPreviewFontSize((prevSize) => (prevSize > 10 ? prevSize - 2 : prevSize));

  const openTuningModal = () => setIsTuningModalOpen(true);
  const closeTuningModal = () => setIsTuningModalOpen(false);

  const openChordModal = () => setIsChordModalOpen(true); // Open chord modal
  const closeChordModal = () => setIsChordModalOpen(false); // Close chord modal

  const updateTuning = (newTuning) => {
    setTuning(newTuning);
    closeTuningModal();
    alert("Tuning updated!");
  };



  const buyCoffee = () => {
    window.open("https://buymeacoffee.com/onlyriley", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen flex flex-col items-center p-8 space-y-4">
      <div className="w-full max-w-screen-lg space-y-4">
        {/* Tab Editor */}
        <div className="flex space-x-2 justify-center">
          <p>Title: </p>
          <textarea 
            className="w-half h-1 py-4 rounded-lg bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 font-mono text-lg"
            onChange={(e) => setTabTitle(e.target.value)}
          />
          <p>Artist: </p>
          <textarea 
            className="w-half h-1 py-4 rounded-lg bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 font-mono text-lg"
            onChange={(e) => setTabArtist(e.target.value)}
          />
        </div>
                <div className="flex space-x-2 justify-center">
          <p>Description: </p>
          <textarea 
            className="w-full h-1 py-4 rounded-lg bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 font-mono text-lg"
            onChange={(e) => setTabDescription(e.target.value)}
          />
          {isSignedIn && <button className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg" onClick={uploadTab}>Upload</button>}
        </div>
        <textarea
          className="w-full h-72 p-4 rounded-lg bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 font-mono text-lg"
          placeholder="Type your guitar tab here..."
          value={tabText}
          onChange={(e) => setTabText(e.target.value)}
        />
        <div className="flex space-x-4 mt-4">
          <button
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg"
            onClick={saveTab}
          >
            Save
          </button>
          <button
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
            onClick={loadTab}
          >
            Load
          </button>
          <button
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            className="px-4 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-lg"
            onClick={insertTemplate}
          >
            Insert Template
          </button>
          <button
            className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
            onClick={downloadTab}
          >
            Download
          </button>
          <button
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg"
            onClick={openTuningModal}
          >
            Change Tuning
          </button>
          <button
            className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg"
            onClick={openChordModal}
          >
            Chord Diagrams
          </button>
          <button
            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg"
            onClick={buyCoffee}
          >
            Buy Me a Coffee ☕
          </button>
        </div>
      </div>
      {/* Tab Preview */}
      <div className="mt-8 w-full max-w-screen-lg">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-2xl font-semibold">Tab Preview</h2>
          <div className="flex space-x-2">
            <button
              className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded-lg"
              onClick={increaseFontSize}
            >
              +
            </button>
            <button
              className="px-2 py-1 bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
              onClick={decreaseFontSize}
            >
              -
            </button>
          </div>
        </div>
        <pre
          className="w-full bg-gray-800 p-4 rounded-lg border border-gray-700 overflow-auto font-mono"
          style={{
            whiteSpace: "pre",
            wordWrap: "normal",
            maxHeight: "4000px",
            fontSize: `${previewFontSize}px`,
          }}
        >
          {tabText}
        </pre>
      </div>

      {/* Tuning Modal */}
      {isTuningModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg w-96">
            <h3 className="text-2xl font-semibold mb-4">Change Tuning</h3>
            {tuning.map((string, index) => (
              <div key={index} className="flex items-center mb-2">
                <label className="mr-4">{`String ${6 - index}:`}</label>
                <input
                  type="text"
                  value={string}
                  maxLength={2}
                  className="w-16 p-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none"
                  onChange={(e) => {
                    const updatedTuning = [...tuning];
                    updatedTuning[index] = e.target.value;
                    setTuning(updatedTuning);
                  }}
                />
              </div>
            ))}
            <div className="flex justify-end mt-4 space-x-4">
              <button
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg"
                onClick={closeTuningModal}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
                onClick={() => updateTuning(tuning)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chord Modal */}
      {isChordModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg w-96">
            <h3 className="text-2xl font-semibold mb-4">Common Guitar Chords</h3>
            <div className="grid grid-cols-2 gap-4">
              {/* Replace these examples with actual diagrams or ASCII art */}
              <div className="text-center">
                <p className="font-bold">C Major</p>
                <pre className="bg-gray-700 p-2 rounded-lg">
                  e|-0-<br />
                  B|-1-<br />
                  G|-0-<br />
                  D|-2-<br />
                  A|-3-<br />
                  E|-x-<br />
                </pre>
              </div>
              <div className="text-center">
                <p className="font-bold">G Major</p>
                <pre className="bg-gray-700 p-2 rounded-lg">
                  e|-3-<br />
                  B|-3-<br />
                  G|-0-<br />
                  D|-0-<br />
                  A|-2-<br />
                  E|-3-<br />
                </pre>
              </div>
              <div className="text-center">
                <p className="font-bold">D Major</p>
                <pre className="bg-gray-700 p-2 rounded-lg">
                  e|-2-<br />
                  B|-3-<br />
                  G|-2-<br />
                  D|-0-<br />
                  A|-x-<br />
                  E|-x-<br />
                </pre>
              </div>
              <div className="text-center">
                <p className="font-bold">A Minor</p>
                <pre className="bg-gray-700 p-2 rounded-lg">
                  e|-0-<br />
                  B|-1-<br />
                  G|-2-<br />
                  D|-2-<br />
                  A|-0-<br />
                  E|-x-<br />
                </pre>
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg"
                onClick={closeChordModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <footer className="mt-8 text-sm text-gray-500 text-center">
        Created by Riley Simmons. <br />
        <a href="https://github.com/Onlyriley/free-guitar-tab-editor">Github (contributions, issues)</a>
      </footer>
    </div>
  );
}

export default TabEditor;
